<template>
  <div class="flex flex-col grow p-5">
    <AttachmentList
      v-for="(list, index) in lists"
      :key="list.id || index"
      :title="list.title"
      :items="list.items"
      :download="download || list.download"
      :preview="preview || list.preview"
      :remove="remove || list.remove"
      @preview="handleViewMedia"
    />
    <MediaViewer
      v-if="media.length"
      v-model:open="openMediaViewer"
      :title="activeMedia.name"
      :src="activeMedia?.urls?.file || activeMedia?.url"
      :type="activeMedia?.mime_type"
      :multiple="media.length > 1"
      @next="next"
      @previous="previous"
    />
  </div>
</template>

<script setup>
import { computed, ref } from "vue";
import { AttachmentList } from "@/SharedComponents/Attachments";
import { MediaViewer } from "@/SharedComponents/Media";

const props = defineProps({
  lists: { type: Array, required: true },
  download: { type: Boolean, required: false },
  preview: { type: Boolean, required: false },
  remove: { type: Boolean, required: false },
});

const media = computed(() =>
  props.lists.reduce((acc, list) => {
    return [...acc, ...list.items.filter((file) => file.preview)];
  }, [])
);

const activeIndex = ref(0);
const openMediaViewer = ref(undefined);

const activeMedia = computed(() => media.value[activeIndex.value]);

function handleViewMedia(file) {
  activeIndex.value = media.value.findIndex((media) => media.id === file.id);
  openMediaViewer.value = true;
}

function next() {
  activeIndex.value += 1;
  if (activeIndex.value === media.value.length) {
    activeIndex.value = 0;
  }
}

function previous() {
  activeIndex.value -= 1;
  if (activeIndex.value < 0) {
    activeIndex.value = media.value.length - 1;
  }
}
</script>
